import * as _ from 'underscore';
import * as ng from 'angular';

import { Experience, ExperienceTypeDef } from '../../';
import { EditorModel } from '../../editor/editor.model';
import { EditorPageModel } from '../../editor/editor-page.model';

const settingsViewUrl = require('./passbook-settings.html');

ng.module('e360')
   .factory('passbookEditorModelFactory', passbookEditorModelFactory);

passbookEditorModelFactory.$inject = ['instanceServiceFactory'];
function passbookEditorModelFactory(instanceServiceFactory) {
   return instanceServiceFactory(PassbookEditorModel);
}

export interface PassbookEditorModelFactory {
   ({campaign, typeDef:ExperienceTypeDef, experience:Experience}):PassbookEditorModel
}

export class PassbookEditorModel extends EditorModel {
   readonly workspaceClass: string;
   readonly pages: PassbookPageModel[];
   readonly settingsView: string = settingsViewUrl;

   static $inject = ['session'].concat(['campaign', 'typeDef', 'experience']);

   constructor(
      private session,
      campaign, typeDef: ExperienceTypeDef, experience: Experience
   ) {
      super(campaign, typeDef, experience);

      this.hasSettings = true;
      this.workspaceClass = 'device passbook';

      if (this.isNew) {
         let brandSettings = this.session.getBrand().settings.experience;
         let defaults = {
            backgroundColor: brandSettings.backgroundColor,
            fontColor: brandSettings.fontColor,
            layout: 'one',
            labelColor: '#444444',
            uploads: {}
         };

         this.experience = {
            campaignId: campaign.id,
            type: typeDef.id,
            settings: ng.copy(defaults)
         };
      }

      this.pages = [new PassbookPageModel(this)];
   }

   // Convenience method for checking if a background image has been set
   private get bgImageSet(): boolean {
      return this.settings.uploads &&
         this.settings.uploads.background &&
         this.settings.uploads.background[this.language];
   }

   // Convenience method used for checking if the font and background color 
   // pickers should be disabled
   get disableColorSettings(): boolean {
      return this.settings.layout === 'one' && this.bgImageSet;
   }

   // Convenience method for getting what fontColor to display
   get displayedFontColor(): string {
      // If the background image is set and the layout is 'one' then set the font-color
      // to white. This is because apple forces the font color of an apple wallet
      // pass to be white when there is a background image showing.
      return this.disableColorSettings ? '#ffffff' : this.settings.fontColor;
   }

   // Convenience method for getting which background image to display
   get displayedBGImage(): string {
      if (this.settings.layout === 'one' && this.bgImageSet) {
         return this.settings.uploads.background[this.language];
      }

      return '';
   }

   // Convenience method for getting which background color to display
   get displayedBGColor(): string {
      // If the background image is set and the layout is 'one' then set the background-color
      // to black. This is because apple forces the background color of an apple wallet
      // pass to be black when there is a background image showing. This background color will
      // be visible if the background image has transparency.
      if (this.disableColorSettings) {
         return '#000';
      }

      return this.settings.backgroundColor;
   }
}

const passbookOneView = require('./passbook-one.html');
const passbookTwoView = require('./passbook-two.html');

class PassbookPageModel extends EditorPageModel {
   constructor(editor: PassbookEditorModel) {
      super(editor);
   }

   get settings() {
      return this.editor.settings;
   }

   get view() {
      if (this.settings.layout == 'one') {
         return passbookOneView;
      } else {
         return passbookTwoView;
      }
   }
}
